/**
 * @owner @Appboy/messaging-experience
 */
import { segmentCohortRemoteLookupValidators } from "../.generated/segmentCohortRemoteLookup";
import type { SegmentCohortRemoteLookupProvider } from "../.generated/segmentCohortRemoteLookup";

export const segmentCohortProvider: SegmentCohortRemoteLookupProvider = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: segmentCohortRemoteLookupValidators,
};
